export default __webpack_public_path__ + "static/media/ada2.590ae812.svg";